import { Component, OnInit } from '@angular/core';
import { ComponentService } from '../../../../../shared/abstract/component.service';

@Component({
  selector: 'app-video-tutorial',
  templateUrl: './video-tutorial.component.html',
  styleUrls: ['./video-tutorial.component.css']
})
export class VideoPlayerDialogComponent extends ComponentService<any> implements OnInit{

  ngOnInit() {

  }

  get videoSrc(): string {
    return this._appsService.language === 'tr-TR'
      ? 'assets/videos/TeamerVideo.mp4'
      : 'assets/videos/TeamerVideo-EN.mp4';
  }

}
